var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8148 13.0391L10.6742 9.89844C11.3539 9.06641 11.7289 8.01875 11.7289 6.875C11.7289 4.18203 9.54618 2 6.85391 2C4.16165 2 2 4.18273 2 6.875C2 9.56727 4.1825 11.75 6.85391 11.75C7.99743 11.75 9.04649 11.3537 9.87735 10.6944L13.018 13.835C13.1492 13.9461 13.2945 14 13.4375 14C13.5805 14 13.7253 13.9451 13.8352 13.8352C14.0539 13.6156 14.0539 13.2594 13.8148 13.0391ZM3.125 6.875C3.125 4.80734 4.80735 3.125 6.875 3.125C8.94266 3.125 10.625 4.80734 10.625 6.875C10.625 8.94266 8.94266 10.625 6.875 10.625C4.80735 10.625 3.125 8.94219 3.125 6.875Z",
    fill: "#787878"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.3d4b455f8b5a223154153951fb61fb89.svg";
export { ForwardRef as ReactComponent };